export function shared(): string {
  return 'shared';
}

/**
 * Sanitize filename: remove characters that could break headers, enable injection, or path traversal
 * Keep percent signs as they're legitimate characters and encodeURIComponent will handle them
 * Removes: double quotes, CR/LF, backslashes, semicolons, forward slashes, and all control chars (C0 and C1)
 * @param filename
 * @returns sanitized filename safe for use in Content-Disposition header and file paths
 */
export function sanitizeFilename(filename: string): string {
  const sanitizedFilename = filename.replace(/["\r\n\\;\/\x00-\x1F\x7F-\x9F]/g, '');
  return sanitizedFilename;
}

/**
 * Build Content-Disposition value per RFC 2616 and RFC 5987. File name is sanitized and encoded
 * to ensure safe transmission and correct handling of special characters and non-ASCII names.
 * @param fileName
 * @param type
 * @returns value for Content-Disposition header, e.g. `attachment; filename="file.txt"; filename*=UTF-8''file.txt`
 */
export function fileContentDisposition(fileName: string, type: 'attachment' | 'inline' = 'attachment'): string {
  const sanitizedFileName = sanitizeFilename(fileName);
  const disposition = `${type}; filename=${encodeURIComponent(sanitizedFileName)}; filename*=UTF-8''${encodeURIComponent(sanitizedFileName)}`;
  return disposition;
}
